// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.create-license-wrapper {
  display: flex;
  flex-direction: column;
  height: auto;
}

.create-license-content {
  padding: 20px 29px;
  overflow-y: auto;
  max-height: 60vh;
}
.create-license-content .form-section h3 {
  font-size: 18px;
  font-weight: 600;
  color: #142A31;
  margin-bottom: 8px;
}
.create-license-content .form-section .description {
  color: #142A31;
  opacity: 0.8;
  font-size: 14px;
  margin-bottom: 24px;
  line-height: 1.21em;
}
.create-license-content .loading-section {
  text-align: center;
  padding: 60px 0;
}
.create-license-content .loading-section .loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(64, 160, 193, 0.2);
  border-top: 3px solid #40A0C1;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}
.create-license-content .loading-section .loading-text {
  color: #142A31;
  font-size: 14px;
  opacity: 0.7;
}
.create-license-content .empty-section {
  text-align: center;
  padding: 60px 0;
}
.create-license-content .empty-section .empty-text {
  color: #142A31;
  font-size: 14px;
  opacity: 0.6;
}
.create-license-content .error-section {
  text-align: center;
  padding: 40px 0;
}
.create-license-content .error-section .error-icon {
  font-size: 48px;
  margin-bottom: 16px;
  color: #FF5555;
}
.create-license-content .error-section h3 {
  font-size: 18px;
  font-weight: 600;
  color: #142A31;
  margin-bottom: 8px;
}
.create-license-content .error-section p {
  color: #142A31;
  font-size: 14px;
  margin-bottom: 24px;
  opacity: 0.8;
}
.create-license-content .pricing-tiers {
  display: grid;
  gap: 16px;
  margin-bottom: 24px;
}
.create-license-content .pricing-tiers .pricing-tier-card {
  border: 2px solid rgba(20, 42, 49, 0.15);
  border-radius: 10px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  background: #FFFFFF;
}
.create-license-content .pricing-tiers .pricing-tier-card:hover {
  border-color: #40A0C1;
  box-shadow: 0 4px 12px rgba(64, 160, 193, 0.15);
  transform: translateY(-2px);
}
.create-license-content .pricing-tiers .pricing-tier-card.selected {
  border-color: #40A0C1;
  background: linear-gradient(135deg, rgba(64, 160, 193, 0.05) 0%, rgba(64, 160, 193, 0.02) 100%);
  box-shadow: 0 4px 16px rgba(64, 160, 193, 0.2);
}
.create-license-content .pricing-tiers .pricing-tier-card:focus {
  outline: 2px solid #40A0C1;
  outline-offset: 2px;
}
.create-license-content .pricing-tiers .pricing-tier-card:not(.selected):focus {
  outline: none;
}
.create-license-content .pricing-tiers .pricing-tier-card .tier-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.create-license-content .pricing-tiers .pricing-tier-card .tier-header .tier-name {
  font-weight: 600;
  font-size: 16px;
  color: #142A31;
}
.create-license-content .pricing-tiers .pricing-tier-card .tier-header .tier-duration {
  font-size: 14px;
  color: #40A0C1;
  font-weight: 600;
  background: rgba(64, 160, 193, 0.1);
  padding: 4px 12px;
  border-radius: 20px;
}
.create-license-content .pricing-tiers .pricing-tier-card .tier-description {
  font-size: 14px;
  color: #142A31;
  opacity: 0.8;
  line-height: 1.21em;
}
.create-license-content .error-message {
  background: rgba(255, 85, 85, 0.1);
  color: #FF5555;
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 14px;
  border: 1px solid rgba(255, 85, 85, 0.2);
  display: flex;
  align-items: center;
  gap: 10px;
}
.create-license-content .error-message:before {
  content: "⚠️";
  font-size: 16px;
}
.create-license-content .form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid rgba(20, 42, 49, 0.1);
  align-items: center;
}
.create-license-content .form-actions .validation-message {
  color: #FF5555;
  font-size: 12px;
  margin-right: auto;
}
.create-license-content .success-section {
  text-align: center;
  padding: 20px 0;
}
.create-license-content .success-section .success-icon {
  width: 64px;
  height: 64px;
  background: #28A745;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: bold;
  margin: 0 auto 24px;
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}
.create-license-content .success-section h3 {
  font-size: 20px;
  font-weight: 600;
  color: #142A31;
  margin-bottom: 12px;
}
.create-license-content .success-section .success-description {
  color: #142A31;
  font-size: 14px;
  margin-bottom: 32px;
  line-height: 1.21em;
  opacity: 0.8;
}
.create-license-content .success-section .license-details {
  background: rgba(20, 42, 49, 0.03);
  border-radius: 10px;
  padding: 24px;
  margin-bottom: 24px;
  text-align: left;
  border: 1px solid rgba(20, 42, 49, 0.1);
}
.create-license-content .success-section .license-details .detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid rgba(20, 42, 49, 0.08);
}
.create-license-content .success-section .license-details .detail-row:last-child {
  border-bottom: none;
}
.create-license-content .success-section .license-details .detail-row .detail-label {
  font-weight: 600;
  color: #142A31;
  font-size: 14px;
  opacity: 0.8;
}
.create-license-content .success-section .license-details .detail-row .detail-value-container {
  display: flex;
  align-items: center;
  gap: 8px;
}
.create-license-content .success-section .license-details .detail-row .detail-value-container .detail-value {
  font-size: 14px;
  color: #142A31;
  font-weight: 500;
}
.create-license-content .success-section .license-details .detail-row .detail-value-container .detail-value.license-key {
  font-family: "Courier New", monospace;
  background: rgba(64, 160, 193, 0.1);
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  color: #40A0C1;
  font-weight: 600;
}
.create-license-content .success-section .license-details .detail-row .detail-value-container .detail-value.status-pending {
  color: #ff9800;
  background: rgba(255, 152, 0, 0.1);
  padding: 4px 12px;
  border-radius: 16px;
  font-weight: 500;
  text-transform: capitalize;
  display: inline-block;
}
.create-license-content .success-section .license-details .detail-row .detail-value-container .copy-button {
  background: rgba(64, 160, 193, 0.1);
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  color: #40A0C1;
}
.create-license-content .success-section .license-details .detail-row .detail-value-container .copy-button:hover {
  background: rgba(64, 160, 193, 0.2);
  transform: scale(1.05);
}
.create-license-content .success-section .license-details .detail-row .detail-value-container .copy-button:active {
  transform: scale(0.95);
}
.create-license-content .success-section .license-details .detail-row .detail-value-container .copy-success {
  color: #28A745;
  font-size: 12px;
  font-weight: 600;
  animation: fadeInOut 2s ease-in-out;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CreateLicenseModal/CreateLicenseModal.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACC,aAAA;EACA,sBAAA;EACA,YAAA;AAAD;;AAGA;EACC,kBAAA;EACA,gBAAA;EACA,gBAAA;AAAD;AAGE;EACC,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AADH;AAIE;EACC,cAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;AAFH;AAMC;EACC,kBAAA;EACA,eAAA;AAJF;AAME;EACC,WAAA;EACA,YAAA;EACA,yCAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;AAJH;AAOE;EACC,cAAA;EACA,eAAA;EACA,YAAA;AALH;AASC;EACC,kBAAA;EACA,eAAA;AAPF;AASE;EACC,cAAA;EACA,eAAA;EACA,YAAA;AAPH;AAWC;EACC,kBAAA;EACA,eAAA;AATF;AAWE;EACC,eAAA;EACA,mBAAA;EACA,cAAA;AATH;AAYE;EACC,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAVH;AAaE;EACC,cAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AAXH;AAeC;EACC,aAAA;EACA,SAAA;EACA,mBAAA;AAbF;AAeE;EACC,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,iDAAA;EACA,mBAAA;AAbH;AAeG;EACC,qBAAA;EACA,+CAAA;EACA,2BAAA;AAbJ;AAgBG;EACC,qBAAA;EACA,+FAAA;EAGA,8CAAA;AAhBJ;AAmBG;EACC,0BAAA;EACA,mBAAA;AAjBJ;AAoBG;EACC,aAAA;AAlBJ;AAqBG;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAnBJ;AAqBI;EACC,gBAAA;EACA,eAAA;EACA,cAAA;AAnBL;AAsBI;EACC,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mCAAA;EACA,iBAAA;EACA,mBAAA;AApBL;AAwBG;EACC,eAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;AAtBJ;AA2BC;EACC,kCAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,wCAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAzBF;AA2BE;EACC,aAAA;EACA,eAAA;AAzBH;AA6BC;EACC,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,2CAAA;EACA,mBAAA;AA3BF;AA6BE;EACC,cAAA;EACA,eAAA;EACA,kBAAA;AA3BH;AA+BC;EACC,kBAAA;EACA,eAAA;AA7BF;AA+BE;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,6CAAA;AA7BH;AAgCE;EACC,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA9BH;AAiCE;EACC,cAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AA/BH;AAkCE;EACC,kCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,uCAAA;AAhCH;AAkCG;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,+CAAA;AAhCJ;AAkCI;EACC,mBAAA;AAhCL;AAmCI;EACC,gBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AAjCL;AAoCI;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AAlCL;AAoCK;EACC,eAAA;EACA,cAAA;EACA,gBAAA;AAlCN;AAoCM;EACC,qCAAA;EACA,mCAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAlCP;AAqCM;EACC,cAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0BAAA;EACA,qBAAA;AAnCP;AAuCK;EACC,mCAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iDAAA;EACA,cAAA;AArCN;AAuCM;EACC,mCAAA;EACA,sBAAA;AArCP;AAwCM;EACC,sBAAA;AAtCP;AA0CK;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;AAxCN;;AAgDA;EACC;IAAK,uBAAA;EA5CJ;EA6CD;IAAO,yBAAA;EA1CN;AACF;AA4CA;EACC;IAAK,UAAA;EAzCJ;EA0CD;IAAM,UAAA;EAvCL;EAwCD;IAAM,UAAA;EArCL;EAsCD;IAAO,UAAA;EAnCN;AACF","sourcesContent":["@import '../../styles/popup-design-system.scss';\n\n.create-license-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: auto;\n}\n\n.create-license-content {\n\tpadding: 20px popup-dim('padding-container');\n\toverflow-y: auto;\n\tmax-height: 60vh;\n\n\t.form-section {\n\t\th3 {\n\t\t\tfont-size: 18px;\n\t\t\tfont-weight: 600;\n\t\t\tcolor: popup-color('text-primary');\n\t\t\tmargin-bottom: 8px;\n\t\t}\n\n\t\t.description {\n\t\t\tcolor: popup-color('text-primary');\n\t\t\topacity: 0.8;\n\t\t\tfont-size: popup-typo('body-size');\n\t\t\tmargin-bottom: 24px;\n\t\t\tline-height: popup-typo('body-line-height');\n\t\t}\n\t}\n\n\t.loading-section {\n\t\ttext-align: center;\n\t\tpadding: 60px 0;\n\n\t\t.loading-spinner {\n\t\t\twidth: 40px;\n\t\t\theight: 40px;\n\t\t\tborder: 3px solid rgba(popup-color('btn-primary'), 0.2);\n\t\t\tborder-top: 3px solid popup-color('btn-primary');\n\t\t\tborder-radius: 50%;\n\t\t\tanimation: spin 1s linear infinite;\n\t\t\tmargin: 0 auto 20px;\n\t\t}\n\n\t\t.loading-text {\n\t\t\tcolor: popup-color('text-primary');\n\t\t\tfont-size: popup-typo('body-size');\n\t\t\topacity: 0.7;\n\t\t}\n\t}\n\n\t.empty-section {\n\t\ttext-align: center;\n\t\tpadding: 60px 0;\n\n\t\t.empty-text {\n\t\t\tcolor: popup-color('text-primary');\n\t\t\tfont-size: popup-typo('body-size');\n\t\t\topacity: 0.6;\n\t\t}\n\t}\n\n\t.error-section {\n\t\ttext-align: center;\n\t\tpadding: 40px 0;\n\n\t\t.error-icon {\n\t\t\tfont-size: 48px;\n\t\t\tmargin-bottom: 16px;\n\t\t\tcolor: popup-color('btn-danger');\n\t\t}\n\n\t\th3 {\n\t\t\tfont-size: 18px;\n\t\t\tfont-weight: 600;\n\t\t\tcolor: popup-color('text-primary');\n\t\t\tmargin-bottom: 8px;\n\t\t}\n\n\t\tp {\n\t\t\tcolor: popup-color('text-primary');\n\t\t\tfont-size: popup-typo('body-size');\n\t\t\tmargin-bottom: 24px;\n\t\t\topacity: 0.8;\n\t\t}\n\t}\n\n\t.pricing-tiers {\n\t\tdisplay: grid;\n\t\tgap: 16px;\n\t\tmargin-bottom: 24px;\n\n\t\t.pricing-tier-card {\n\t\t\tborder: 2px solid rgba(popup-color('text-primary'), 0.15);\n\t\t\tborder-radius: popup-dim('border-radius');\n\t\t\tpadding: 20px;\n\t\t\tcursor: pointer;\n\t\t\ttransition: all popup-effect('transition-duration') popup-effect('transition-ease');\n\t\t\tbackground: popup-color('bg-primary');\n\n\t\t\t&:hover {\n\t\t\t\tborder-color: popup-color('btn-primary');\n\t\t\t\tbox-shadow: 0 4px 12px rgba(popup-color('btn-primary'), 0.15);\n\t\t\t\ttransform: translateY(-2px);\n\t\t\t}\n\n\t\t\t&.selected {\n\t\t\t\tborder-color: popup-color('btn-primary');\n\t\t\t\tbackground: linear-gradient(135deg,\n\t\t\t\t\trgba(popup-color('btn-primary'), 0.05) 0%,\n\t\t\t\t\trgba(popup-color('btn-primary'), 0.02) 100%);\n\t\t\t\tbox-shadow: 0 4px 16px rgba(popup-color('btn-primary'), 0.2);\n\t\t\t}\n\n\t\t\t&:focus {\n\t\t\t\toutline: 2px solid popup-color('btn-primary');\n\t\t\t\toutline-offset: 2px;\n\t\t\t}\n\n\t\t\t&:not(.selected):focus {\n\t\t\t\toutline: none;\n\t\t\t}\n\n\t\t\t.tier-header {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\talign-items: center;\n\t\t\t\tmargin-bottom: 12px;\n\n\t\t\t\t.tier-name {\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\tcolor: popup-color('text-primary');\n\t\t\t\t}\n\n\t\t\t\t.tier-duration {\n\t\t\t\t\tfont-size: popup-typo('body-size');\n\t\t\t\t\tcolor: popup-color('btn-primary');\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tbackground: rgba(popup-color('btn-primary'), 0.1);\n\t\t\t\t\tpadding: 4px 12px;\n\t\t\t\t\tborder-radius: 20px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.tier-description {\n\t\t\t\tfont-size: popup-typo('body-size');\n\t\t\t\tcolor: popup-color('text-primary');\n\t\t\t\topacity: 0.8;\n\t\t\t\tline-height: popup-typo('body-line-height');\n\t\t\t}\n\t\t}\n\t}\n\n\t.error-message {\n\t\tbackground: rgba(popup-color('btn-danger'), 0.1);\n\t\tcolor: popup-color('btn-danger');\n\t\tpadding: 12px 16px;\n\t\tborder-radius: 6px;\n\t\tmargin-bottom: 20px;\n\t\tfont-size: popup-typo('body-size');\n\t\tborder: 1px solid rgba(popup-color('btn-danger'), 0.2);\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 10px;\n\n\t\t&:before {\n\t\t\tcontent: '⚠️';\n\t\t\tfont-size: 16px;\n\t\t}\n\t}\n\n\t.form-actions {\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\tgap: popup-dim('btn-gap');\n\t\tmargin-top: 30px;\n\t\tpadding-top: 20px;\n\t\tborder-top: 1px solid rgba(popup-color('text-primary'), 0.1);\n\t\talign-items: center;\n\n\t\t.validation-message {\n\t\t\tcolor: popup-color('btn-danger');\n\t\t\tfont-size: 12px;\n\t\t\tmargin-right: auto;\n\t\t}\n\t}\n\n\t.success-section {\n\t\ttext-align: center;\n\t\tpadding: 20px 0;\n\n\t\t.success-icon {\n\t\t\twidth: 64px;\n\t\t\theight: 64px;\n\t\t\tbackground: popup-color('btn-success');\n\t\t\tcolor: white;\n\t\t\tborder-radius: 50%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tfont-size: 28px;\n\t\t\tfont-weight: bold;\n\t\t\tmargin: 0 auto 24px;\n\t\t\tbox-shadow: 0 4px 12px rgba(popup-color('btn-success'), 0.3);\n\t\t}\n\n\t\th3 {\n\t\t\tfont-size: 20px;\n\t\t\tfont-weight: 600;\n\t\t\tcolor: popup-color('text-primary');\n\t\t\tmargin-bottom: 12px;\n\t\t}\n\n\t\t.success-description {\n\t\t\tcolor: popup-color('text-primary');\n\t\t\tfont-size: popup-typo('body-size');\n\t\t\tmargin-bottom: 32px;\n\t\t\tline-height: popup-typo('body-line-height');\n\t\t\topacity: 0.8;\n\t\t}\n\n\t\t.license-details {\n\t\t\tbackground: rgba(popup-color('text-primary'), 0.03);\n\t\t\tborder-radius: popup-dim('border-radius');\n\t\t\tpadding: 24px;\n\t\t\tmargin-bottom: 24px;\n\t\t\ttext-align: left;\n\t\t\tborder: 1px solid rgba(popup-color('text-primary'), 0.1);\n\n\t\t\t.detail-row {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\talign-items: center;\n\t\t\t\tpadding: 12px 0;\n\t\t\t\tborder-bottom: 1px solid rgba(popup-color('text-primary'), 0.08);\n\n\t\t\t\t&:last-child {\n\t\t\t\t\tborder-bottom: none;\n\t\t\t\t}\n\n\t\t\t\t.detail-label {\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tcolor: popup-color('text-primary');\n\t\t\t\t\tfont-size: popup-typo('body-size');\n\t\t\t\t\topacity: 0.8;\n\t\t\t\t}\n\n\t\t\t\t.detail-value-container {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tgap: 8px;\n\n\t\t\t\t\t.detail-value {\n\t\t\t\t\t\tfont-size: popup-typo('body-size');\n\t\t\t\t\t\tcolor: popup-color('text-primary');\n\t\t\t\t\t\tfont-weight: 500;\n\n\t\t\t\t\t\t&.license-key {\n\t\t\t\t\t\t\tfont-family: 'Courier New', monospace;\n\t\t\t\t\t\t\tbackground: rgba(popup-color('btn-primary'), 0.1);\n\t\t\t\t\t\t\tpadding: 6px 12px;\n\t\t\t\t\t\t\tborder-radius: 6px;\n\t\t\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\t\t\tcolor: popup-color('btn-primary');\n\t\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t&.status-pending {\n\t\t\t\t\t\t\tcolor: #ff9800;\n\t\t\t\t\t\t\tbackground: rgba(255, 152, 0, 0.1);\n\t\t\t\t\t\t\tpadding: 4px 12px;\n\t\t\t\t\t\t\tborder-radius: 16px;\n\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t\ttext-transform: capitalize;\n\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.copy-button {\n\t\t\t\t\t\tbackground: rgba(popup-color('btn-primary'), 0.1);\n\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\tpadding: 6px;\n\t\t\t\t\t\tborder-radius: 6px;\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\ttransition: all popup-effect('transition-duration') popup-effect('transition-ease');\n\t\t\t\t\t\tcolor: popup-color('btn-primary');\n\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tbackground: rgba(popup-color('btn-primary'), 0.2);\n\t\t\t\t\t\t\ttransform: scale(1.05);\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t&:active {\n\t\t\t\t\t\t\ttransform: scale(0.95);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.copy-success {\n\t\t\t\t\t\tcolor: popup-color('btn-success');\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\tanimation: fadeInOut 2s ease-in-out;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n@keyframes spin {\n\t0% { transform: rotate(0deg); }\n\t100% { transform: rotate(360deg); }\n}\n\n@keyframes fadeInOut {\n\t0% { opacity: 0; }\n\t20% { opacity: 1; }\n\t80% { opacity: 1; }\n\t100% { opacity: 0; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
